<template>
  <el-dialog :title="$t('修改税率信息')" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form id="idez97UO" class="defBord" size="small" style="width: 70%;margin: 20px auto" :model="form"
      :rules="formRules" ref="form">
      <el-form-item id="id1RddrE" class=" defBord  " :label="$t('税率分类')" prop="name" :label-width="formLabelWidth"
        :rules="[{ required: true, message: $t('请输入税率分类') }]">
        <el-input v-model="form.name" autocomplete="off" style="width: 60%"></el-input>
      </el-form-item>
      <el-form-item id="idVViJLx" class=" defBord  " :label="$t('税率')" prop="rate" :label-width="formLabelWidth"
        :rules="[{ required: true, message: $t('请输入税率值') }, { pattern: /^\d+(\.\d+)?$/, trigger: 'blur', message: $t('请输入数字') }]">
        <el-input id="idg6Thvg" style="width: 20%" class="defBord" v-model="form.rate" autocomplete="off">
        </el-input>%
      </el-form-item>
      <el-form-item :label="$t('适用菜品分类')" prop="category_id" :rules="[{ required: true, message: $t('请选择菜品分类') }]"
                    :label-width="formLabelWidth">
        <el-checkbox-group v-model="form.category_id">
          <el-checkbox v-for="item in storeList" :key="item.category_id" :label="item.category_id + ''" :disabled="item.disabled">
            {{item.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">{{ $t('取 消') }}</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">{{ $t('确 定') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
export default {
  components: {},
  data() {
    return {
      form: {
        "id": 0,
        "name": "",
        "rate": "",
        "category_id": []
      },
      storeList: [],
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: true,
      loading: false,
      formRules: {
        name: [{
          required: true,
          message: this.$t('请输入分类名称'),
          trigger: 'blur'
        }],
      },
      extistCategory:null,
    };
  },
  props: ['open_tax_edit', 'editRateform'],
  created() {
    this.getData();
    this.form.id = this.editRateform.id
    this.form.name = this.editRateform.name
    this.form.rate = this.editRateform.rate
    this.form.category_id = this.editRateform.category_id;
  },
  mounted() {


  },
  methods: {
    isCategoryDisabled(categoryId) {
      if (!this.extistCategory) {
        console.log('extistCategory is not set');
        return true; // 如果extistCategory不存在，禁用分类
      }
      const categoryIdInt = parseInt(categoryId);
      const extistCategoryNumbers = this.extistCategory.map(Number);
      const formCategoryNumbers = this.form.category_id.map(Number); // 将form.category_id中的元素转换为数字
      // 如果当前分类在编辑的税率设置中，或者不在已存在的分类列表中，或者是当前正在编辑的分类，则不禁用
      if (formCategoryNumbers.includes(categoryIdInt) || !extistCategoryNumbers.includes(categoryIdInt) || categoryIdInt === this.editRateform.category_id) {
        return false;
      } else {
        return true;
      }
    },

    getData() {
      SupplierApi.addGetTaxRate({}, true)
        .then(data => {
          this.storeList = data.data.storeList;
          this.extistCategory = data.data.extistCategory.map(Number);
          // 在获取数据后重新计算每个菜品分类的禁用状态
          this.storeList.forEach(item => {
            item.disabled = this.isCategoryDisabled(item.category_id);
          });
        })
        .catch(error => { });
    },
    /*修改用户*/
    addUser() {
      let self = this;
      let params = this.form
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          SupplierApi.editTaxRate(params, true).then(data => {
            self.loading = false;
            self.$message({
              message: self.$t('修改成功'),
              type: 'success'
            });
            self.dialogFormVisible(true);
          }).catch(error => {
            self.loading = false;
          });
        }
      });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeTaxRateDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeTaxRateDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style>.img {
  margin-top: 10px;
}</style>



// WEBPACK FOOTER //
// src/components/buildStore/goods/taxrate/Edit.vue